"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCodeCitiesMapper = void 0;
var AreaCodeCitiesMapper = /** @class */ (function () {
    function AreaCodeCitiesMapper(data) {
        this.localData = data;
    }
    AreaCodeCitiesMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AreaCodeCitiesMapper;
}());
exports.AreaCodeCitiesMapper = AreaCodeCitiesMapper;
//# sourceMappingURL=AreaCodeCitiesMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AreaCodeCitiesMapper.js
// module id = 2058
// module chunks = 8